<template>
  <el-dialog
          title="QA提示"
          :visible.sync="shown"
          class="examination-QA-layer"
          ref="examinationQA"
          :before-close="()=>handleCancel('form')"
  >
    <div class="examination-QA-layer-wrap">
      <div class="target-details">
        详情: <span class="target-text" v-html="targetStr"/>
      </div>
      <div class="QA-info-area">
        <ul class="QA-content-item examination-QA-header">
          <li class="first">序号</li>
          <li class="second">问题描述</li>
          <li class="last">严重等级</li>
        </ul>
        <ul class="QA-content-item"
            v-for="(item,index) in getFrangmentQAInfo"
            :keys="item.id"
            :class="{'QA-last-item':(getFrangmentQAInfo.length)===(index+1)}"
        >
          <li class="first">{{(index+1).toString().padStart(2, '0')}}</li>
          <li class="second">{{(item.errorDesc) || '佚失'}}</li>
          <li class="last" :class="errLevelClass(item)">{{errLevel(item)}}</li>
        </ul>
      </div>
      <el-form ref="form" :model="form" :rules="rules">
        <el-form-item class="remarks-content" prop="comment">
          <el-input type="textarea" v-model="form.comment" maxlength="50" placeholder="请输入内容(最大长度50个字符)"/>
        </el-form-item>
        <el-form-item class="button-box">
          <el-row class="button-box-inside" :gutter="40">
            <el-col :span="12">
              <el-button type="primary" @click="()=>handleSubmit('form')">
                添加
              </el-button>
            </el-col>
            <el-col :span="12">
              <el-button @click="()=>handleCancel('form')">取消</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "ExaminationQA",
    props: ['shown','targetStr'],
    data() {
      return {
        form: {
          comment: ''
        },
        QAInfo: {},
        rules: {
          comment: [
            {required: true, message: '请填写备注信息', trigger: 'blur'}
          ]
        }
      }
    },

    computed: {
      //获取片段QA列表
      getFrangmentQAInfo() {
        return this.$store.getters['editor/getFragmentQAList'];
      },



    },


    methods: {
      //错误级别
      errLevel(item) {
        if (!!item && !!(item.grade)) {
          switch (parseInt(item.grade)) {
            case 0:
              return '轻微错误';
            case 1:
              return '一般错误';
            case 2:
              return '严重错误';
            default:
              return '轻微错误';
          }
        } else {
          return '轻微错误';
        }
      },

      //错误级别
      errLevelClass(item) {
        if (!!item && !!(item.grade)) {
          switch (parseInt(item.grade)) {
            case 0:
              return 'slight-error';
            case 1:
              return 'commonly-error';
            case 2:
              return 'serious-error';
            default:
              return 'slight-error';
          }
        } else {
          return 'slight-error';
        }
      },
      //确定
      handleSubmit(form) {
        const self = this;
        let urlInfo = self.$store.getters['editor/getUrlInfo'];
        self.$refs[form].validate((valid) => {
          Reflect.set((self.QAInfo), 'commentType', 3);
          Reflect.set((self.QAInfo), 'comment', (self.form.comment));
          Reflect.set((self.QAInfo), 'transFileId', (urlInfo.fileId));
          if (valid) {
            self.$store.dispatch('editor/setFragmentInfo', (self.QAInfo)).then((res) => {
              if (res) {
                self.handleCancel('form');
                //提交完成获取当前句的所有批注
                let params = {transFileId: (urlInfo.fileId)};
                let sentIdList = Array.of((self.QAInfo.sentId));
                Reflect.set(params, 'sentIdList', sentIdList);
                self.$store.dispatch('editor/getCurrentRemarksInfo', params)
              } else {
                self.$message({
                  message: '添加批注失败',
                  type: 'warning'
                });
              }
            });
          } else {
            console.log('信息错误');
            return false;
          }
        });
      },

      //取消
      handleCancel(form) {
        this.$nextTick(() => {
          this.$refs[`${form}`].resetFields();
          this.$emit("handleCancel");
        })
      }
    },
  }
</script>

<style lang="less" scoped>
  @import './assets/style.less';
</style>